import bizAiService from '@/modules/bizai/services/BizAiService';
import { i18n } from '@/plugins/i18n';
import buildRecommendationLaunch from '@/modules/pulse/utils/pulseConversita';
import { pulseItemCategoryTab, pulseCategoryLabelKey, pulseItemTitle } from '@/modules/pulse/utils/pulseItemDisplay';
import {
  PULSE_VIEW,
  pulseViewApiParam,
  pulseDueFilterParams,
  PULSE_CATEGORY,
  PULSE_MAX_PAGE_LIMIT,
} from '@/modules/pulse/utils/pulseConstants';

// README, "Client card".

const toTime = (value) => {
  const time = new Date(value ?? NaN).getTime();
  return Number.isNaN(time) ? null : time;
};

const itemDate = (item) => item?.due_at || item?.created_at || null;

const mostUrgentFirst = (a, b) => {
  const byDate = (toTime(itemDate(a)) ?? Infinity) - (toTime(itemDate(b)) ?? Infinity);
  if (byDate) return byDate;
  return (toTime(b.created_at) ?? 0) - (toTime(a.created_at) ?? 0);
};

const toRow = (item) => ({
  uid: item.uid,
  title: pulseItemTitle(item),
  date: itemDate(item),
  createdAt: item.created_at,
});

const itemsInTab = (items, tab) => items
  .filter((item) => pulseItemCategoryTab(item) === tab)
  .sort(mostUrgentFirst);

const state = {
  matterUid: null,
  items: [],
};

const mutations = {
  setItems(state, { matterUid, items }) {
    state.matterUid = matterUid;
    state.items = items;
  },
};

let requestCounter = 0;

const actions = {
  async fetchItems({ commit }, { matterUid, view = PULSE_VIEW.MY } = {}) {
    if (!matterUid) return null;
    requestCounter += 1;
    const requestId = requestCounter;
    const response = await bizAiService.getRecommendations({
      context: matterUid,
      view: pulseViewApiParam(view),
      per_page: PULSE_MAX_PAGE_LIMIT,
      producer: 'any',
      ...pulseDueFilterParams(),
    });
    const items = response?.airecommendations || [];
    if (requestId === requestCounter) commit('setItems', { matterUid, items });
    const needsAttention = itemsInTab(items, PULSE_CATEGORY.NEEDS_ATTENTION)[0];
    return {
      matterUid,
      needsAttention: needsAttention ? toRow(needsAttention) : null,
      upcoming: itemsInTab(items, PULSE_CATEGORY.UPCOMING).map(toRow),
    };
  },
  openItem({ dispatch, state }, uid) {
    const item = state.items.find((matterItem) => matterItem.uid === uid);
    if (!item) {
      console.error('Cannot open Pulse item of matter: not loaded', uid);
      return;
    }
    const labelKey = pulseCategoryLabelKey(pulseItemCategoryTab(item));
    dispatch(
      'AiChatStore/openRecommendation',
      buildRecommendationLaunch(item, labelKey ? i18n.t(labelKey) : ''),
      { root: true },
    );
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
